import {createApi} from '@reduxjs/toolkit/query/react'
import {axiosBaseQuery} from '../../../../rtkQueryUtils'
import {GUILD_API_ENDPOINT} from '../../../../constants/backendUrls'
import {IdType} from '../../../../util/models/IdType'
import {FileDTO} from '../../../../service/model/ServiceRequest'
import {setSnackbarMessage} from '../../../../genericComponents/commonSlice'
import {saveFileFromBlobStorage} from '../../../../service/serviceRequests/serviceRequestAsyncActions'
import {GenericRequestResponse} from '../../../../service/serviceRequests/rtkServiceRequestApi'

export const ITEMS_EXTRACTION = 'ItemsExtraction'

export const itemsExtractionAPI = createApi({
    reducerPath: 'ItemsExtractionAPI',
    keepUnusedDataFor: 0,
    tagTypes: [ITEMS_EXTRACTION],
    baseQuery: axiosBaseQuery({baseUrl: `${GUILD_API_ENDPOINT}/api/v1/datx/`}),
    endpoints: (builder) => ({
        extractionItems: builder.mutation<any, {
            itemIds: IdType[],
            displaySetIds: IdType[],
            guildId?: IdType
        }>({
            query: ({itemIds, displaySetIds, guildId}) => ({
                url: 'items-extraction',
                method: 'POST',
                data: {itemIds, displaySetIds, guildId}
            }),
            transformErrorResponse: () => 'Error extracting items',
            invalidatesTags: [ITEMS_EXTRACTION]
        }),
        getItemsExtractionFileLink: builder.mutation<any, { fileId: IdType }>({
            queryFn: async ({fileId}, {dispatch}, extraOptions, baseQuery) => {
                try {
                    const getFileLinkEndpoint = await baseQuery({
                        url: `files/items-extraction/${fileId}/download`,
                        method: 'GET'
                    })

                    const file = (
                        getFileLinkEndpoint.data as GenericRequestResponse<FileDTO | null>
                    )?.data

                    if (!file) {
                        dispatch(setSnackbarMessage('File is not available.'))
                        return {error: 'File is not available.'}
                    }
                    await saveFileFromBlobStorage(file)

                    return {data: file}
                } catch (error: any) {
                    dispatch(setSnackbarMessage('File is not available.'))
                    return {error: error?.response}
                }
            }
        })
    })
})

export const {useExtractionItemsMutation, useGetItemsExtractionFileLinkMutation} = itemsExtractionAPI